var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.36 89.995 c -5.471 0 -10.942 -2.082 -15.107 -6.248 c -4.035 -4.036 -6.258 -9.4 -6.258 -15.107 c 0 -5.708 2.222 -11.073 6.258 -15.107 l 16.659 -16.66 c 1.563 -1.562 4.095 -1.562 5.658 0 c 1.562 1.563 1.562 4.095 0 5.658 L 11.91 59.19 c -2.525 2.525 -3.914 5.881 -3.914 9.45 s 1.39 6.926 3.914 9.45 c 5.211 5.21 13.69 5.212 18.899 0 l 16.661 -16.66 c 1.561 -1.563 4.096 -1.563 5.657 0 c 1.563 1.562 1.563 4.095 0 5.657 l -16.66 16.66 C 32.302 87.913 26.831 89.995 21.36 89.995 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.259 54.299 c -1.024 0 -2.048 -0.391 -2.828 -1.172 c -1.563 -1.562 -1.563 -4.095 0 -5.657 l 16.66 -16.661 c 5.211 -5.211 5.211 -13.689 0 -18.899 c -2.525 -2.524 -5.881 -3.914 -9.45 -3.914 s -6.926 1.39 -9.45 3.914 L 42.531 28.57 c -1.563 1.562 -4.095 1.562 -5.658 0 c -1.562 -1.563 -1.562 -4.095 0 -5.658 l 16.66 -16.66 c 4.035 -4.035 9.399 -6.258 15.107 -6.258 c 5.707 0 11.072 2.222 15.107 6.258 c 8.33 8.331 8.33 21.884 0 30.215 l -16.66 16.66 C 66.307 53.908 65.283 54.299 64.259 54.299 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.338 68.663 c -1.024 0 -2.048 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.657 l 39.325 -39.325 c 1.561 -1.562 4.096 -1.562 5.657 0 c 1.563 1.563 1.563 4.095 0 5.658 L 28.167 67.491 C 27.385 68.272 26.362 68.663 25.338 68.663 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.12f2735b6009409a939a8391e3a23719.svg";
export { ForwardRef as ReactComponent };